export enum MimeType {
    GOOGLE_FOLDER = "application/vnd.google-apps.folder",
    GOOGLE_DOCUMENT = "application/vnd.google-apps.document",
    WORD_DOCUMENT = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    PDF = "application/pdf",
    HTML = "text/html",
}